import meQuery from 'user/queries/me.gql';
import User from 'entities/User';

function modifyResponse(me: any) {
  if (me.prompts_inventory) {
    // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'p' implicitly has an 'any' type.
    me.prompts_inventory.map((p) => {
      p.__typename = 'Prompt';
      return p;
    });
  }
  if (me.permissions) {
    me.permissions.__typename = 'UserPermissions';
  }
  if (me.features) {
    me.featureFlags = {
      ...me.features,
      __typename: 'FeatureFlags',
    };
    delete me.features;
  }
  if (me.needs) {
    me.needs.__typename = 'UserNeeds';
  }
  if (me.office_hours) {
    me.office_hours.__typename = 'OfficeHours';
    // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'day' implicitly has an 'any' type.
    me.office_hours.available.forEach((day) => (day.__typename = 'OfficeHoursDay'));
  }
  if (me.experiments) {
    const variantMap = me.experiments;
    const trackable: string[] = me.experiments_trackable || [];
    delete me.experiments_trackable;
    me.experiments = Object.keys(me.experiments).map((name) => ({
      name,
      variation: variantMap[name],
      trackable: trackable.includes(name),
      __typename: 'Experiment',
    }));
  }
  if (me.grade_level) {
    me.grade_level.__typename = 'GradeLevel';
  }
  if (me.profile_picture) {
    me.profile_picture.__typename = 'StreamMessageFile';
    if (me.profile_picture.urls) {
      me.profile_picture.urls.__typename = 'FileUrls';
    }
  }

  if (me.settings) {
    me.settings.__typename = 'UserLimits';
    me.settings.messages.__typename = 'MessageLimits';
    me.settings.messages.characters.__typename = 'MessageCharacterLimits';
    me.settings.chats.__typename = 'ChatLimits';
    me.settings.chats.members.__typename = 'ChatMemberLimits';
  }

  // from me.gql
  [
    'can_chat',
    'can_call_from_dialer',
    'can_collect_money',
    'can_compose_announcements',
    'can_compose_group_chat',
    'can_create_group',
    'can_own_groups',
    'can_create_activity',
    'can_send_money',
    'can_add_parent',
    'can_add_child',
  ].forEach((key) => {
    me.permissions[key] = !!me.permissions[key];
  });

  me.preferences.__typename = 'UserPreferences';

  if (me.quick_promotions) {
    // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'p' implicitly has an 'any' type.
    me.quick_promotions.forEach((p) => {
      p.__typename = 'QuickPromotion';
      if (p.primary_action) {
        p.primary_action.__typename = 'QuickPromotionAction';
      }
      if (p.secondary_action) {
        p.secondary_action.__typename = 'QuickPromotionAction';
      }
    });
  }
}

export default function fakeQueryResultForUser(user: User): any {
  const me = {
    ...user.get('__rawData'),
    name: user.getName(),
    unreads: null,
    __typename: 'User',
  };
  modifyResponse(me);
  return { data: { me }, query: meQuery };
}
